export default __webpack_public_path__ + "static/media/EmptyBoxWithoutText.86fdbe2b.png";